import { gql } from '@apollo/client';

export const DOG_RESCUE_PAGINATION = gql`
    query dogRescues($page: Int, $limit: Int, $specializations: [String!], $center: CoordinatesInputObject, $bounds: BoundsInputObject) {
        dogRescues(page: $page, limit: $limit, specializations: $specializations, center: $center, bounds: $bounds) {
            collection {
                id
                logo
                rescueName
                bio
                slug
                city
                cityRank
                country
                countryRank
                state
                stateRank
                specializations
                latitude
                longitude
                testimonials(page: 1, limit: 1) {
                    id
                    reviewerName
                    testimonial
                }
            }
            metadata {
                totalCount
                totalPages
            }
        }
    }
`;
